import type { IconData } from '@stacksjs/iconify-core'

export const darkDislayModeSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5c12.426 0 22.5 10.074 22.5 22.5S36.426 46.5 24 46.5S1.5 36.426 1.5 24S11.574 1.5 24 1.5M33 16c.929 0 1.69-1.087 1.044-1.753A13.96 13.96 0 0 0 24 10.001c-7.732 0-14 6.268-14 14s6.268 14 14 14c3.94 0 7.499-1.627 10.043-4.246C34.69 33.089 33.929 32 33 32a8 8 0 0 1 0-16\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default darkDislayModeSolid
